import { render, staticRenderFns } from "./CompanyActionRecommendEditPage.vue?vue&type=template&id=34967114&"
import script from "./CompanyActionRecommendEditPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyActionRecommendEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports